import config from '../config';

export default function getRepositoryPulls(repositoryId) {
    return fetch(`${config.github.apiBaseURL}/search/issues?q=+type:pr+repo:${repositoryId}+state:open&sort=created&order=desc`);
}